import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { handleGoogleCallbackThunk } from '../thunks/thunks';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const GoogleCallback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');

      if (!code) {
        toast.error('Google login failed: No code received!');
        navigate('/register');
        return;
      }

      try {
        await dispatch(handleGoogleCallbackThunk(code)).unwrap();
        toast.success('Google login successful!');
        navigate('/');
      } catch (error) {
        toast.error(error || 'Google login failed!');
        navigate('/register');
      }
    };

    handleCallback();
  }, [dispatch, navigate]);

  return <div>Loading...</div>;
};

export default GoogleCallback;
